import React from 'react';

import { SimpleTag as Tag } from '@atlaskit/tag';
import TagGroup from '@atlaskit/tag-group';

import { QUESTIONS_TOPIC_NATIVE } from '@confluence/named-routes/entry-points/routes';

export type Topic = {
	name: string;
};

type QuestionTopicsProps = {
	topics?: Array<Topic>;
};

export const QuestionTopics: React.FC<QuestionTopicsProps> = ({ topics }) => {
	if (!topics || topics.length === 0) {
		return null;
	}

	return (
		<TagGroup>
			{topics.map(({ name }) => (
				<Tag text={name} key={name} href={QUESTIONS_TOPIC_NATIVE.toUrl({ topicName: name })} />
			))}
		</TagGroup>
	);
};
